import { ApiRestService } from './../_service/api-rest.service';
import { ToastrService } from 'ngx-toastr';
import { ApiRestService as FileApiRestService} from './../../shared/_services/api-rest.service' ;
import { DownloadService } from './../../shared/_services/download.service';
import { DatePipe } from '@angular/common';
import { Azienda } from './../models/Azienda';
import { AziendeStoreService } from './../_service/aziende-store.service';
import { AuthenticationService } from './../../Login/_services/authentication.service';
import { PersonaleStoreService } from './../_service/personale-store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { Attivita } from './../models/Attivita';
import { Persona } from '../models/persona';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RicercaPaginazione } from './../models/sendpersonale';
import { Subscription } from 'rxjs';
import { ClassicType } from './../../shared/models/ClassicType';
import { constants } from 'buffer';

@Component({
  selector: 'app-attivita-cliente',
  templateUrl: './attivita-cliente.component.html'
})
export class AttivitaClienteComponent implements OnInit {
  fileAsBase64: string = undefined;
  fileName: string = undefined;
  filelabel: string = "";
  @Input()clienteSelezionato: Azienda;
  subscriptions: Subscription = new Subscription();
  tipiAttivita: ClassicType[] = [];
  tipologieSelezionate: ClassicType[] = [];
  listaNomiPersonale: Persona[] = [];
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'label',
    allowSearchFilter: false ,
  };
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  AttivitaSelezionata: Attivita;
  Responsabile: Persona[] = []
  collectionSize = 0;
  closedCollectionSize = 0;
  openedCollectionSize = 0;
  AttivitaFiltrate: Attivita[] = [];
  Attivita: Attivita[] = [];
  form: FormGroup;
  EditForm: FormGroup;
  submitted: boolean = false;
  constructor(private modalService: NgbModal,
    private personaleStore: PersonaleStoreService,
    private clientiStore: AziendeStoreService,
    private authSvc: AuthenticationService,
    private formBuilder: FormBuilder,
    private datepipe: DatePipe,
    private downloadService: DownloadService,
    private fileApiRestService: FileApiRestService,
    private ApiRestService: ApiRestService,
    private toastService: ToastrService
  ) {
    this.form = this.formBuilder.group({
      attivita: ['', Validators.required],
      data: [Validators.required],
      chiusa: [],
      allegato: [],
      note: [],
    });
    this.EditForm = this.formBuilder.group({
      attivita: ['', Validators.required],
      data: [Validators.required],
      datachiusura: [],
      chiusa: [],
      allegato: [],
      note: [],
    });
  }
  get f() { return this.form.controls; }
  get ef() { return this.EditForm.controls; }
  ngOnInit() {
    this.Responsabile.push(this.authSvc.currentUserValue);
    this.clientiStore.getTipologieAtivita();
    // this.subscriptions.add(this.clientiStore.$selectedAzienda.subscribe((item) => {
    //   this.clienteSelezionato = item;
    // }));
    this.subscriptions.add(this.clientiStore.$attivitaSelezionata.subscribe((item) => {
      if (item && item !== null) {
        this.resetEditField();
        this.AttivitaSelezionata = item;
        this.setEditForm(item);
      }
    }));
    this.subscriptions.add(this.clientiStore.$attivita.subscribe((items) => {
      if (items && items !== null){
        this.collectionSize = items.length;
        this.openedCollectionSize = items.filter(x => !x.att_chiusa).length
        this.closedCollectionSize = items.filter(x => x.att_chiusa).length
      }
      this.AttivitaFiltrate = items;
      this.Attivita = items;
    }));
    this.subscriptions.add(this.clientiStore.$tipiAttivita.subscribe((items) => {
      if (items && items !== null && items.length > 0){
        this.tipiAttivita = items;
      }
    }));
    this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe((items) => {
      if (items && items !== null)
        this.listaNomiPersonale = items.data;
    }));
  }

  getDaForm(): Attivita {
    const nuovo = new Attivita();
    nuovo.attivita = this.f.attivita.value;
    try {
      nuovo.data_attivita = this.datepipe.transform(this.f.data.value, 'yyyy-MM-ddTHH:mm');
    } catch (ex) { }
    nuovo.att_chiusa = false;
    if (this.f.chiusa.value != null)
      nuovo.att_chiusa = this.f.chiusa.value;
    nuovo.note = this.f.note.value;
    nuovo.file = this.fileName;
    nuovo.allegato = this.fileAsBase64;
    nuovo.cliente = this.clienteSelezionato.id;
    if (this.Responsabile && this.Responsabile.length > 0)
      nuovo.resp_attivita = this.Responsabile[0].id;
    if (this.tipologieSelezionate && this.tipologieSelezionate.length > 0)
      nuovo.tipo = this.tipologieSelezionate[0].id;
    return nuovo;
  }
  getDaEditForm(): Attivita {
    const nuovo = new Attivita();
    nuovo.id = this.AttivitaSelezionata.id;
    nuovo.attivita = this.ef.attivita.value;
    try {
      nuovo.data_attivita = this.datepipe.transform(this.ef.data.value, 'yyyy-MM-ddTHH:mm');
      nuovo.data_chiusura = this.datepipe.transform(this.ef.datachiusura.value, 'yyyy-MM-ddTHH:mm');
    } catch (ex) { }
    nuovo.att_chiusa = false;
    if (this.ef.chiusa.value != null)
      nuovo.att_chiusa = this.ef.chiusa.value;
    nuovo.note = this.ef.note.value;
    nuovo.file = this.fileName;
    nuovo.allegato = this.fileAsBase64;
    nuovo.cliente = this.clienteSelezionato.id;
    if (this.Responsabile && this.Responsabile.length > 0)
      nuovo.resp_attivita = this.Responsabile[0].id;
    if (this.tipologieSelezionate && this.tipologieSelezionate.length > 0)
      nuovo.tipo = this.tipologieSelezionate[0].id;
    //  TODO: tipo
    return nuovo;
  }

  setEditForm(item: Attivita) {
    this.EditForm = this.formBuilder.group({
      attivita: [item.attivita, Validators.required],
      data: ['',Validators.required],
      datachiusura: [''],
      chiusa: [item.att_chiusa],
      allegato: [],
      note: [item.note],
    });
    if (item.file != "")
      this.filelabel = item.file;
    this.EditForm.controls.data.setValue(item.data_attivita.split('.')[0]);
    if (item.data_chiusura && item.data_chiusura !== null)
      this.EditForm.controls.datachiusura.setValue(item.data_chiusura.split('.')[0]);
    this.Responsabile = [];
    if (item.responsabile && item.responsabile !== null)
      this.Responsabile.push(item.responsabile);
    if (item.tipoObject && item.tipoObject !== null )
      this.tipologieSelezionate.push(item.tipoObject);
  }

  resetAddField() {
    this.form = this.formBuilder.group({
      attivita: ['', Validators.required],
      data: [Validators.required],
      chiusa: [],
      allegato: [],
      note: [],
    });
    this.fileAsBase64 = undefined;
    this.fileName = undefined;
    this.Responsabile = [];
    this.Responsabile.push(this.authSvc.currentUserValue);
    this.tipologieSelezionate=[]
  }
  resetEditField() {
    this.fileAsBase64 = undefined;
    this.fileName = undefined;
    this.Responsabile = [];
    this.tipologieSelezionate = []
  }


  async filechange(event) {
    const file: Blob = event.target.files[0];
    if (file.size > 5242880) {
      this.toastService.warning("Questo file è troppo grande per essere caricato.", "Attenzione!")
      return;
    }else{
      console.log(file.size);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result.toString().length > 100){
          this.fileAsBase64 = reader.result.toString();
          this.fileName = event.target.files[0].name;
          this.filelabel = event.target.files[0].name;
        } else
          this.fileAsBase64 = undefined;
      };
    }
  }



  download(item: Attivita) {
    var idAllegato = parseInt(item.allegato);
    if (!isNaN(idAllegato)) {
      this.fileApiRestService.downloadFle(idAllegato).subscribe(data => {
        this.downloadService.downloadFile(data)
      });
    } else {
      this.toastService.info("Allegato non disponibile", "Ooops!")
    }
  }

  delete(item) {
    if (confirm("Sei sicuro di voler eliminare questa attività?"))
      this.clientiStore.deleteAttivita(item, this.clienteSelezionato);
  }
  saveModalButton() {
    this.ApiRestService.addNewAttivita(this.getDaForm()).subscribe((data) => {
      this.clientiStore.Refresh(this.clienteSelezionato);
      this.closeBtnClick();
    });
  }
  saveEditModalButton() {
    this.clientiStore.updateAttivita(this.getDaEditForm(), this.clienteSelezionato);
    this.closeBtnClick();
  }
  openModal(targetModal: NgbModal) {
    this.resetAddField();
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }
  openEditModal(targetModal: NgbModal, item: Attivita) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
    this.clientiStore.updateSelectedAttivita(item);
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }
  filtroConcluse() {
    this.AttivitaFiltrate = this.Attivita.filter(x => x.att_chiusa);
  }
  filtroAperte() {
    this.AttivitaFiltrate = this.Attivita.filter(x => !x.att_chiusa);
  }
}
